import { classNames } from "../../UI/Utils/classNames.ts";
import {
  deltaClass,
  formatDelta,
  saturation,
} from "./closerAvailabilityHistoryStats.ts";

const thBase =
  "px-3 py-3 bg-gray-50 text-sm font-bold uppercase text-gray-700 whitespace-nowrap";
const tdBase =
  "px-3 py-3 text-sm whitespace-nowrap border-b border-gray-100 tabular-nums";

export const thClass = `${thBase} text-right`;
export const thLeftClass = `${thBase} text-left`;
export const tdClass = `${tdBase} text-right`;
export const tdLeftClass = `${tdBase} text-left`;

export function DeltaCell({
  value,
  className,
}: {
  value: number | null;
  className?: string;
}) {
  return (
    <td
      className={classNames(
        tdClass,
        "font-semibold",
        value === null ? "text-gray-300" : deltaClass(value),
        className ?? "",
      )}
    >
      {value === null ? "—" : formatDelta(value)}
    </td>
  );
}

export function SaturationCell({
  calls,
  effective,
  className,
}: {
  calls: number;
  effective: number;
  className?: string;
}) {
  const pct = saturation(calls, effective);
  return (
    <td className={classNames(tdClass, className ?? "")}>
      <span className="inline-flex items-center gap-2">
        <span className="inline-block w-12 h-1.5 rounded bg-gray-200 overflow-hidden">
          <span
            className="block h-full bg-blue-500"
            style={{ width: `${pct}%` }}
          />
        </span>
        {pct}%
      </span>
    </td>
  );
}
